import FuturePortalLayout from './FuturePortalLayout';

export default FuturePortalLayout;
